module.exports = __webpack_public_path__ + "static/media/25.f9b9ccb4.jpg";